export default "__VITE_ASSET__BGa2EyjI__"